<template>
  <div>
    <div class="col-lg-8 ml-auto mr-auto">
      <b-overlay :show="loading" rounded="sm" variant="secondary">
        <b-card no-body>
          <div class="mx-3">
            <!-- TODO: form-wizard error color -->
            <!-- TODO: if has owning account but needs onboard - go straight to profile onboard step -->
            <form-wizard @on-loading="setLoading" @on-validate="handleValidation" @on-complete="onComplete" color="#5378b1" error-color="#e74c3c" stepSize="sm">

              <b-card-header slot="title">
                <h3>Hello. Lets get you setup.</h3>
              </b-card-header>
<!--              TODO: if user owns an account already - hard skip to profile form-->
              <tab-content v-if="userOwnsNoAccount && invites.length === 0" title="Workspace" :before-change="createAccount" icon="ni ni-settings" >
                <onboard-workspace ref="accountRef"></onboard-workspace>
              </tab-content>
              <tab-content v-if="invites.length > 0" title="Invites" :before-change="validateInvites" icon="ni ni-send" >
                <onboard-invites ref="inviteRef"></onboard-invites>
              </tab-content>
              <tab-content title="Profile" :before-change="validateProfile" icon="ni ni-single-02">
                <profile-form ref="profileRef"></profile-form>
              </tab-content>

              <b-card-footer slot="footer" slot-scope="props">
                <div class="wizard-footer-left">
                  <b-button v-if="props.activeTabIndex > 0" @click="props.prevTab()" :style="props.fillButtonStyle">Back</b-button>
                </div>
                <b-form-invalid-feedback :state="errorMessage === undefined">
                  {{errorMessage}}
                </b-form-invalid-feedback>
                <div class="wizard-footer-right">
                  <b-button @click="props.nextTab()" :style="props.fillButtonStyle">Next</b-button>

                  <!--                  <b-button v-if="!props.isLastStep" @click="props.nextTab()" :style="props.fillButtonStyle">Next</b-button>-->
<!--                  <b-button v-else @click="finishOnboard" :style="props.fillButtonStyle">Finish</b-button>-->
                </div>
              </b-card-footer>

            </form-wizard>
          </div>
        </b-card>
      </b-overlay>
    </div>
  </div>

</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';

import { mapGetters } from 'vuex';
import OnboardWorkspace from '#/ui/Components/Onboard/OnboardWorkspace.vue';
import OnboardInvites from '#/ui/Components/Onboard/OnboardInvites.vue';
import ProfileForm from '#/ui/Components/User/UserProfileForm.vue';

export default {
  name: 'OnboardFormWizard',
  components: {
    ProfileForm,
    OnboardInvites,
    OnboardWorkspace,
    FormWizard,
    TabContent,
  },
  data() {
    return {
      loading: false,
      title: 'Hello. Lets get you setup.',
      errorMessage: undefined,
    };
  },
  computed: {
    ...mapGetters(['userOwnsNoAccount']),
    ...mapGetters('user', {
      invites: 'invites',
    }),
  },
  methods: {
    onComplete() {
      // this reload is no longer necessary due to equivalent call in profile validate
      // window.location.reload(false);
    },
    setLoading(value) {
      this.loading = value;
    },
    handleValidation(isValid, tabIndex) {
      console.info(`handleValidation Tab: ${tabIndex} valid: ${isValid}`);
    },
    createAccount() {
      return this.$refs.accountRef.createAccount();
    },
    validateInvites() {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('loadUserAccounts').finally(() => {
          if (this.$store.getters.fallbackProjectId) {
            this.errorMessage = undefined;
            resolve(true);
            return;
          }
          this.errorMessage = 'Please join an account first';
          reject();
        });
      });
    },
    validateProfile() {
      return new Promise((resolve, reject) => this.$refs.profileRef.saveProfile().then((response) => {
        this.$router.replace('/home');
      }).catch((error) => {
        console.error('error validating profile', error);
        reject(new Error('error validating profile'));
      }));
    },
  },
};
</script>

<style scoped>

</style>
